@if (draft(); as draft) {
  <odl-dialog
    class="annotation-dialog"
    [label]="'QUESTIONS.NOTE_TITLE' | translate"
    [open]="true"
    (odl-close)="cancel()"
  >
    @if (canManageQuestions()) {
      <textarea
        #annotationTextarea
        class="annotation-textarea"
        rows="5"
        [attr.placeholder]="'QUESTIONS.WRITE_YOUR_NOTE_PLACEHOLDER' | translate"
        [value]="text()"
        (input)="updateText(annotationTextarea.value)"
      ></textarea>
    } @else {
      <p class="annotation-text" [innerHTML]="linkedText()"></p>
    }

    @if (embedImageUrl(); as imageUrl) {
      <img class="annotation-embed-image" [src]="imageUrl" alt="" />
    } @else if (embedHtml(); as html) {
      <div class="annotation-embed" [innerHTML]="html"></div>
    }

    @if (canManageQuestions()) {
      <div slot="footer" class="dialog-footer">
        <div class="dialog-footer-start">
          @if (draft.id) {
            <odl-button variant="text" [disabled]="saving()" (click)="confirmDelete.set(true)">
              {{ 'DELETE' | translate }}
            </odl-button>
          }
        </div>
        <div class="dialog-footer-end">
          <odl-button variant="secondary" [disabled]="saving()" (click)="cancel()">
            {{ 'CANCEL' | translate }}
          </odl-button>
          <odl-button variant="primary" [disabled]="!isValid() || saving()" (click)="save()">
            {{ (saving() ? 'SAVING' : 'SAVE') | translate }}
          </odl-button>
        </div>
      </div>
    }
  </odl-dialog>

  @if (confirmDelete()) {
    <odl-dialog
      class="annotation-delete-dialog"
      [label]="'QUESTIONS.DELETE_TITLE_NOTE' | translate"
      [open]="true"
      (odl-close)="confirmDelete.set(false)"
    >
      {{ 'QUESTIONS.DELETE_BODY_NOTE' | translate }}
      <div slot="footer" class="dialog-footer">
        <odl-button variant="secondary" (click)="confirmDelete.set(false)">
          {{ 'CANCEL' | translate }}
        </odl-button>
        <odl-button variant="primary" (click)="confirmDeleteAnnotation()">
          {{ 'DELETE' | translate }}
        </odl-button>
      </div>
    </odl-dialog>
  }
}
